// Setup › People & access › KPI visibility at `/c/{slug}/setup/kpi-visibility` (KPI-VISIBILITY;
// core, managers): who sees whose KPI data (features/settings/kpi-visibility.tsx).
import { createRoute } from "@tanstack/react-router";
import { isManager } from "../features/company";
import { KpiVisibilityScreen } from "../features/settings/kpi-visibility";
import { useCompany } from "../features/use-feature";
import { NoAccessPage } from "../pages/status-pages";
import { setupRoute } from "./c.$slug.setup";

export const setupKpiVisibilityRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "kpi-visibility",
  component: function KpiVisibility() {
    const { api } = setupKpiVisibilityRoute.useRouteContext();
    const company = useCompany();
    if (!isManager(company)) return <NoAccessPage what="KPI visibility" slug={company.slug} />;
    return <KpiVisibilityScreen api={api} company={company} />;
  },
});
